// Resume.js
import React from 'react';
import ResumeSlider from './ResumeSlider';

const Resume = () => {
  return (
    <div>
      <a href="#Resume" style={{ textDecoration: 'none' }}><ResumeSlider /></a>
    </div>
  );
};

export default Resume;
